import { appActions } from 'store/app/appSlice';
import { signOut } from 'store/auth/authAsync';
import Statuses from 'types/Statuses';

const notificationMiddleware = ({ dispatch }:any) => (next:any) => (action:any) => {
  const { type, payload } = action;

  if ( type.includes('/rejected') ){
    if (payload?.message === 'Account disabled') {
      dispatch(signOut());
      dispatch(appActions.toggleDisabledAccountDialog());
      return next(action);
    }

    if (type === 'currentUser/Get current user/rejected') {
      return next(action);
    }
      
    if (payload){
      dispatch(appActions.createNotification({ message: payload.message || 'An error', status: Statuses.Error }));
    }
  }
  return next(action);
}

export default notificationMiddleware;